const heroProductAccordion = () => ({
  open: '',

  toggle(id) {
    if (this.open === id) {
      this.open = '';
      return;
    }

    this.open = id;
  },
});

export default heroProductAccordion;
